import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import MemberProfileMain from "./MemberProfileMain";
import { useQuery } from "@tanstack/react-query";
import { getMemberByToken } from "../../services/memberServices";
import { getNewsByMemberId } from "../../services/newsServices";
import Cookies from "js-cookie";

const MemberProfile = () => {
  useEffect(() => {
    document.title = "Member Profile | Society of Aquaculture Professionals";
  }, []);

  const token = Cookies.get("token");

  // Fetch member by token
  const {
    data: memberData,
    isLoading: isMemberLoading,
    isError: isMemberError,
    error: memberError,
  } = useQuery({
    queryKey: ["memberProfile"],
    queryFn: () => getMemberByToken(token),
    enabled: !!token,
  });

  const member = memberData?.data?.member || null;
  const leadershipRole = memberData?.data?.leadershipRoles || null;

  const {
    data: memberNewsData,
    isLoading: isNewsLoading,
    isError: isNewsError,
    error: newsError,
    refetch,
  } = useQuery({
    queryKey: ["memberNews", member?._id],
    queryFn: () => getNewsByMemberId(member._id),
    enabled: !!member?._id,
  });

  const memberNews = memberNewsData?.data || [];

  return (
    <>
      <Header />
      <MemberProfileMain
        member={member}
        leadershipRole={leadershipRole}
        memberNews={memberNews}
        refetch={refetch}
      />
      <Footer />
    </>
  );
};

export default MemberProfile;
